/****************** 速度转换 ****************/
import { distanceMile2Km, distanceKm2Mi } from './distance';
// 将速度单位为（千米/小时）的数值，转换为其他速度单位的数值
export const speedKmhToOther = (unitName, value, fix = 2) => {
  let result = 0;
  value = Number(value);

  switch (unitName) {
    case 'km/h':
      result = Number(value.toFixed(fix));
      break;
    case 'mph':
      result = distanceKm2Mi(value, fix);
      break;
  }
  return result;
};

// 将其他速度单位的数值，转换为速度单位为（千米/小时）的数值
export const speedToKmh = (unitName, value, fix = 2) => {
  let result = 0;
  value = Number(value);

  switch (unitName) {
    case 'km/h':
      result = Number(value.toFixed(fix));
      break;
    case 'mph':
      result = distanceMile2Km(value, fix);
      break;
  }
  return result;
};
